import {
  Box,
  Button,
  Modal as ChakraModal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from '@chakra-ui/react'
import React, { useEffect } from 'react'
import { UploadLayout } from '../../UploadLayout'

export function Modal({ item, isBlocked }) {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <>
      <Button
        onClick={onOpen}
        bgColor={'#378BBF'}
        color={'#fff'}
        size="sm"
        fontSize="sm"
        borderRadius="sm"
        _hover={{
          filter: 'brightness(0.8)',
        }}
        isDisabled={item.validacao === 'FINALIZADO' || isBlocked}
      >
        Upload Layout
      </Button>

      <ChakraModal
        closeOnOverlayClick={false}
        isOpen={isOpen}
        onClose={onClose}
        size="5xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Upload Layout - {item.numero_nota}</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <Box
              w={'100%'}
              mx={'auto'}
              alignItems={'center'}
              justifyContent={'center'}
              display={'flex'}
              flexDirection={'column'}
            >
              <Text
                as={'h1'}
                fontSize={'1.1rem'}
                fontWeight={'bold'}
                color={'gray.500'}
              >
                Observação do Layout
              </Text>
              <Text
                as={'p'}
                fontSize={'1rem'}
                fontWeight={'normal'}
                color={'gray.500'}
              >
                {item.observacoes}
              </Text>
            </Box>
            <UploadLayout item={item} onClose={onClose} />
          </ModalBody>

          <ModalFooter>
            <Button onClick={onClose}>Cancelar</Button>
          </ModalFooter>
        </ModalContent>
      </ChakraModal>
    </>
  )
}
